import { FormInputsType } from '@microservices/wiskey-react-components/dist/types/forms'

import { useDepartmentOptions } from '@pages/BarDiagramPage/hooks/useDepartmentOptions'
import { useRosterQualOptions } from '@pages/BarDiagramPage/hooks/useRosterQualOptions'

import { GENERATOR_INPUT_TYPE } from '@constants'

// TODO Необходимо убирать эти хардкодные фильтры для Ростера
const useInputs = ({
  hideHardCodeFilters,
}: {
  // Параметр для хардкодных фильтров Ростера
  hideHardCodeFilters: boolean
}) => {
  const staffQualOptions = useRosterQualOptions({ hideHardCodeFilters })
  const departmentOptions = useDepartmentOptions({ hideHardCodeFilters })

  const filterInputs: FormInputsType[] = [
    {
      name: 'fromDay',
      inputType: GENERATOR_INPUT_TYPE.DATE_TIME_PICKER,
      label: 'From Day',
      formatDate: 'DD.MM.YYYY',
      dateTimePickerViews: ['day'],
    },
    ...(hideHardCodeFilters
      ? []
      : [
          {
            name: 'department',
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            label: 'Department',
            autocompleteOptions: departmentOptions,
          },
          {
            name: 'qual',
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            label: 'Qual',
            autocompleteOptions: staffQualOptions,
          },
        ]),

    {
      name: 'showFormatDate',
      inputType: GENERATOR_INPUT_TYPE.CHECKBOX,
      label: 'Show dates',
    },
  ]

  return {
    filterInputs,
  }
}

export default useInputs
